import { useConnectModal, useOpenModal } from '@rainbow-modules/hooks';
import Footer from 'components/Footer';
import { Outlet, useParams } from 'react-router-dom';
import useRedirectWhenNotAdmin from 'hooks/useRedirectWhenNotAdmin';
import { ADD_EDIT_LLM_RESPONDER_MODAL } from '../../constants';
import CreateEditResponderForm from './CreateResponderForm';
import { StyledDrawer } from './styled';

type FormOpenMode = 'edit' | 'create';

const LLMResponders = () => {
    const { agentId = '' } = useParams();

    useRedirectWhenNotAdmin({});

    const connectedAddModifyProps = useConnectModal(
        ADD_EDIT_LLM_RESPONDER_MODAL,
        { size: 'small' },
    );

    const [, closeModal] = useOpenModal(ADD_EDIT_LLM_RESPONDER_MODAL);
    const { mode, responderData = {}, ...modalProps } = connectedAddModifyProps;

    return (
        <>
            <Outlet />
            <Footer />
            <StyledDrawer
                slideFrom="right"
                header="Create AI Persona"
                {...modalProps}
            >
                <CreateEditResponderForm
                    mode={mode as FormOpenMode}
                    agentId={agentId}
                    onRequestClose={closeModal}
                    {...(responderData as object)}
                />
            </StyledDrawer>
        </>
    );
};

export default LLMResponders;
